// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"10620893","455":"5469de30","977":"92344965"}[chunkId] + ".chunk.js";
};